import { render } from "./LineHeight.vue?vue&type=template&id=466448a8&scoped=true&ts=true"
import script from "./LineHeight.vue?vue&type=script&lang=ts"
export * from "./LineHeight.vue?vue&type=script&lang=ts"

import "./LineHeight.vue?vue&type=style&index=0&id=466448a8&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466448a8"]])

export default __exports__